import { Outlet } from "react-router-dom";
type Props = {};

const RouteParent = (props: Props) => {
  return <Outlet />;
};

export default RouteParent;
